import currency from 'currency.js';

export const calculateBase = (fxRate: string, percent: string) => {
	const value = currency(fxRate, {precision: 4}).multiply(1 + (Number(percent)/100)).value;
	return currency(value, {precision: 4});
};